<template>
    <nav class="navbar">
        <div class="navbar-wrapper" ref="navbarWrapper">
            <ul class="navbar-list">
                <li v-for="(category, index) in categories" :key="index" @click="selectCategory(category.title)"
                    :class="{ 'selected': category.isSelected }">
                    {{ category.title }}
                </li>
            </ul>
        </div>
    </nav>
</template>

<script>
import { fetchAllCategories } from '@/api/CategoryAPI';
import { gsap } from 'gsap';

export default {
    data() {
        return {
            categories: [],
        };
    },
    async mounted() {
        this.categories = await fetchAllCategories();
        this.categories.unshift({ title: 'Menu', isSelected: true });
        this.animateNavbar();
    },
    methods: {
        selectCategory(category) {
            this.categories.forEach(cat => {
                cat.isSelected = (cat.title === category);
            });
            this.$emit('update:selectedCategory', category);
        },
        animateNavbar() {
            gsap.from(this.$refs.navbarWrapper.children, { opacity: 0, duration: 1, y: -50, stagger: 0.2, ease: 'power2.out' });
        },
    },
};
</script>

<style scoped>
.navbar {
    background-color: var(--background-color);
    overflow-x: auto;
}

.navbar-wrapper {
    white-space: nowrap;
    padding-left: 15px;
    padding-right: 15px;
}

.navbar-list {
    list-style-type: none;
    padding: 0;
    margin: 0;
}

.navbar-list li {
    display: inline-block;
    padding: 10px;
    cursor: pointer;
    color: var(--text-color);
}

.navbar-list li.selected {
    border-radius: 50px;
    background-color: var(--accent-color);
}

.navbar-list li:hover {
    border-radius: 50px;
    background-color: var(--accent-color);
}
</style>